import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SortableItem } from "react-easy-sort";
import SettingTextField from "../../../components/SettingTextField";
import SettingSelectField from "../../../components/SettingSelectField";
import SelectizeTextField from "../../../components/SelectizeTextField";
import styles from "./Course.module.css";
import { ReactComponent as EditIcon } from "../../../assets/images/edit3.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete3.svg";
import { ReactComponent as MoveIcon } from "../../../assets/images/expand_vertical.svg";

const CourseCard = ({
  course,
  editCourse,
  onEditClick,
  onDeleteClick,
  theme_mode,
  onSetCourse,
  onSetCourseType,
  onSetCourseCategories,
  onUpdateCourse,
  onCancelCourse,
  CourseTypeList,
  categoryList,
  themeMode,
  editError,
}) => {
  const editable = editCourse?._id === course._id;

  return (
    <SortableItem key={course._id}>
      <Box
        className={styles.courseView}
        style={{ backgroundColor: theme_mode.inputBg4 }}
        pr={0.5}
        pl={0.5}
        pb={editable ? 1.5 : 0}
        mb={1}
        pt={editable ? 1.5 : 0}
      >
        <Box className={`${styles?.["course-move-icon"]}`}>
          <MoveIcon width={20} height={20} />
        </Box>
        <Box
          className={`${styles?.["course-name-view"]}`}
          id={"courseId" + course._id}
          pr={2}
        >
          <Box mb={editable ? 1 : 0}>
            {editable ? (
              <SettingTextField
                page={"course"}
                editable={editable}
                backgroundColor={theme_mode.inputBg5}
                disabledBg={theme_mode.inputBg4}
                disabledColor={theme_mode.cardText}
                value={editCourse.name}
                setValue={onSetCourse}
                label={""}
                placeholder={""}
                required={true}
                variant={"filled"}
                error={editError?.course}
              />
            ) : (
              <Typography className={`${styles?.["course-name-text"]}`}>
                {course.name}{" "}
                <span
                  style={{
                    background: "#999",
                    padding: "0.375rem 0.625rem",
                    borderRadius: "0.5rem",
                    color: "#ffffff",
                    fontSize: "0.75rem",
                    marginLeft: "0.5rem",
                  }}
                >
                  {course?.courseType}
                </span>
              </Typography>
            )}
          </Box>
          {editable ? (
            <Box mb={1}>
              <SettingSelectField
                page={"course"}
                value={editCourse.courseType}
                setValue={onSetCourseType}
                editable={editable}
                placeholder={"Select course type"}
                required={true}
                variant={"filled"}
                menuList={CourseTypeList}
                backgroundColor={theme_mode.inputBg5}
                error={editError?.courseType}
              />
            </Box>
          ) : null}
          <Box pl={editable ? 0 : 1.5} pb={1.5}>
            {editable ? (
              <SelectizeTextField
                page={"course"}
                tagColor={
                  themeMode == "light" ? "#CCCCCC" : theme_mode.inputBg4
                }
                value={editCourse._idRestaurantCategory}
                onChange={onSetCourseCategories}
                backgroundColor={theme_mode.inputBg5}
                options={categoryList}
                variant={"filled"}
                label={""}
                placeholder={
                  editCourse._idRestaurantCategory?.length
                    ? ""
                    : "Select Categories"
                }
                error={editError?.catgeories}
              />
            ) : (
              <Box className={styles.catListView}>
                {course._idRestaurantCategory.map((c, i2) => (
                  <Box
                    key={i2}
                    style={{
                      backgroundColor: theme_mode.inputBg5,
                    }}
                    className={styles.catListNameView}
                    mb={0.5}
                    mr={1}
                    px={1}
                    py={0.4}
                  >
                    <Typography
                      className={styles.catListNameText}
                      style={{
                        color: theme_mode.text,
                      }}
                    >
                      {c.name}
                    </Typography>
                  </Box>
                ))}
                {course._idRestaurantCategory.length === 0 && (
                  <Typography className={styles.catListNameText}>
                    No Categories
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </Box>
        {editable ? (
          <Box>
            <Box
              onClick={onUpdateCourse}
              className={styles.updateBtn}
              sx={{
                backgroundColor: theme_mode.btnBg4,
              }}
            >
              <Typography
                className={styles.updateBtnText}
                style={{ color: theme_mode.btnText }}
              >
                Update
              </Typography>
            </Box>
            <Box
              onClick={onCancelCourse}
              className={styles.updateBtn}
              sx={{
                mt: 1,
                backgroundColor: theme_mode.redBg,
              }}
            >
              <Typography
                className={styles.updateBtnText}
                style={{ color: theme_mode.btnText }}
              >
                Cancel
              </Typography>
            </Box>
          </Box>
        ) : (
          <>
            <Box
              ml={1}
              mr={2}
              className={styles.actionBtn}
              onClick={() => onEditClick(course)}
              sx={{
                path: {
                  stroke: theme_mode.iconBg,
                },
              }}
            >
              <EditIcon width={20} height={20} />
            </Box>
            <Box
              mr={2}
              className={styles.actionBtn}
              onClick={() => onDeleteClick(course)}
              sx={{
                path: {
                  stroke: theme_mode.iconBg,
                },
              }}
            >
              <DeleteIcon width={20} height={20} />
            </Box>
          </>
        )}
      </Box>
    </SortableItem>
  );
};

export default CourseCard;
